export default __webpack_public_path__ + "static/media/home-about.f2f77bf7.png";